<div class="card bg-secondary-light">
  <div class="card-header text-center btn-secondary"
       [id] ="fkkUniversal? 'cardHead'+kostenId:'cardHead'+'X'">
    <fa-icon *ngIf="!(!fkkUniversal)&&!readonly"
             type="btn btn-secondary-icon" [icon]="faTrash"
             class="fa-xl custom-card-btn-delete"
             title = "{{ 'FAHRKOSTEN-DETAIL.NACHWEIS-LOESCHEN' | translate }}"
             [id]="fkkUniversal? 'delBtn'+kostenId:'delBtn'+'X'"
             (click)="deleteFkkUniversal()"
    ></fa-icon>
  </div>

  <form [formGroup]="fahrkostenKostenUniversalForm"
        class="card-body"
        [id] ="fkkUniversal? 'cardBody'+kostenId:'cardBody'+'X'">

    <!--universale Felder-->
    <div id="befoerderungAuswahl" class="row row-cols-1 form-group  mt-0 mb-0">
      <div class="col mt-0 mb-0">
        <app-custom-select id="befoerderung"
                           placeholder="-"
                           [customFormGroup]="fahrkostenKostenUniversalForm"
                           [items]="optionBefoerderung"
                           bindLabel="name"
                           bindValue="id"
                           [multiple] = false
                           [clearable] = false
                           [label] = "fieldConfigService.getFieldLabel('befoerderung', fieldConfig, 'FAHRKOSTEN-DETAIL.BEFOERDERUNG' | translate)"
                           [readonly] = "readonly">
        </app-custom-select>
      </div>
    </div>
    <div id="datumAuswahl" class="row row-cols-2 form-group mb-0">
      <div class="col mt-0 mb-0">
        <app-custom-select id="monat"
                           placeholder="-"
                           [customFormGroup]="fahrkostenKostenUniversalForm"
                           [items]="monateList"
                           bindLabel="monatName"
                           bindValue="monatName"
                           [multiple] = false
                           [clearable] = false
                           [label] = "fieldConfigService.getFieldLabel('monat', fieldConfig, 'STANDARD.MONAT' | translate)"
                           [readonly] = "readonly"
                           (onchange) = "updateDatepickerStartDate()"
        ></app-custom-select>
      </div>
      <div class="col mt-0 mb-0">
        <app-custom-select id="jahr"
                           placeholder="-"
                           [customFormGroup]="fahrkostenKostenUniversalForm"
                           [items]="jahreList"
                           bindLabel="jahr"
                           bindValue="jahr"
                           [multiple] = false
                           [clearable] = false
                           [label] = "fieldConfigService.getFieldLabel('jahr', fieldConfig, 'STANDARD.JAHR' | translate)"
                           [readonly] = "readonly"
                           (onchange) = "updateDatepickerStartDate()"
        ></app-custom-select>
      </div>
    </div>
    <ng-template #selectedDate let-date>
      <span
        [style] = "isInGefahreneTage(date,'gefahreneTage')? 'background-color:lightpink;border-radius:50%;padding:2px;text-align:right;':'background-color:white;border-radius:50%;padding:2px;text-align:right;'">
        {{date.day}}
      </span>
    </ng-template>
    <div  id="gefahreneTageAuswahl"
          class="row row-cols-1 form-group mt-0 mb-3">
      <div class="col col-lg">
        <label>
          {{fieldConfigService.getFieldLabel('gefahreneTageAuswahl', fieldConfig, 'FAHRKOSTEN-DETAIL.GEFAHREN' | translate)}}
        </label>
        <br>
        <div class="input-group" (click)="(!readonly)? dgefahreneTage.toggle():null">
          <div class="input-group-prepend" >
            <span class="input-group-text">
              <fa-icon [icon]="faCalendar" type="button"
                       style="margin-left:-3px;margin-right:-3px;"
                       class="fa-xl custom-card-btn-calendar datepicker"
                       title = "{{ 'FAHRKOSTEN-DETAIL.GEFAHREN' | translate }}"
                       [id]="fkkUniversal? 'datepickerBtn'+fkkUniversal.kostenId:'datepickerBtn'+'Y'"
              ></fa-icon>
            </span>
          </div>
          <input id="gefahreneTage" name="gefahreneTage" type="text"
                 readonly = "readonly"
                 class="gefahreneTage form-control"
                 formControlName="gefahreneTage"
          >
          <!--dummy input field to which datepicker is anchored
          typical ways to hide it didn't work without disabling datepicker
          and datepicker cannot be attached to existing input fields,
          because it overwrites their content-->
          <input ngbDatepicker #dgefahreneTage="ngbDatepicker"
                 style="width:0;height:0;border:0;padding:0;margin:0;"
                 autoclose = false
                 (dateSelect)="selectionDate($event)"
                 [dayTemplate]="selectedDate"
                 navigation = "none"
                 outsideDays = "hidden"
                 [startDate] = "datepickerStartDate"
                 [readonly] = "readonly"
                 id="datum"
                 formControlName="datum"
          >
        </div>
      </div>
    </div>
    <!--ende: universale Felder-->

    <!--felder aus fahrkostenKosten-->
    <div  *ngIf="effectivelyVisible.includes('belegArt')"
          id="belegAuswahl"
          class="row row-cols-1 form-group  mt-0 mb-0">
      <div class="col mt-0 mb-0">
        <app-custom-input id="belegArt"
                          [customFormGroup] = "fahrkostenKostenUniversalForm"
                          [label] = "fieldConfigService.getFieldLabel('belegArt', fieldConfig, 'FAHRKOSTEN-DETAIL.BELEGART' | translate)"
                          [readonly] = "readonly"
        ></app-custom-input>
      </div>
    </div>
    <div  *ngIf="effectivelyVisible.includes('belegAnzahl')"
          id="anzahlPreise"
          class="row justify-content-between" >
      <div class="col mt-0 mb-0">
        <app-custom-input id="belegAnzahl"
                          [type] = "'number'"
                          [min]="0"
                          [max]="365"
                          [customFormGroup] = "fahrkostenKostenUniversalForm"
                          [label] = "fieldConfigService.getFieldLabel('belegAnzahl', fieldConfig, 'FAHRKOSTEN-DETAIL.ANZAHL' | translate)"
                          [readonly] = "readonly"
                          (click) = recalcGesamtpreis()
        ></app-custom-input>
      </div>
      <div  *ngIf="effectivelyVisible.includes('einzelpreis')"
            class="col" >
        <app-custom-input
          id="einzelpreis"
          [customFormGroup]="fahrkostenKostenUniversalForm"
          [label]="fieldConfigService.getFieldLabel('einzelpreis', fieldConfig, 'FAHRKOSTEN-DETAIL.EINZELPREIS' | translate)"
          [readonly] = "readonly"
          [placeholder]="'0,00'"
          [extra_field_text]="'STANDARD.Currency' | translate"
          (click) = recalcGesamtpreis()
          (onchange) = recalcGesamtpreis()
        ></app-custom-input>
      </div>
    </div>
    <!--ende: felder aus fahrkostenKosten-->

    <!--felder aus fahrkostenFahrzeug-->
    <div id="fahrzeugAuswahl" class="row row-cols-2 form-group mt-0 mb-0">
      <div  *ngIf="effectivelyVisible.includes('fahrzeugtyp')"
            class="col">
        <app-custom-input id="fahrzeugtyp"
                          [customFormGroup] = "fahrkostenKostenUniversalForm"
                          [label] = "fieldConfigService.getFieldLabel('fahrzeugtyp', fieldConfig, 'FAHRKOSTEN-DETAIL.FAHRZEUGTYP' | translate)"
                          [readonly] = "readonly"
        ></app-custom-input>
      </div>
      <div *ngIf="effectivelyVisible.includes('kennzeichen')"
           class="col">
        <app-custom-input id="kennzeichen"
                          [customFormGroup] = "fahrkostenKostenUniversalForm"
                          [label] = "fieldConfigService.getFieldLabel('kennzeichen', fieldConfig, 'FAHRKOSTEN-DETAIL.KENNZEICHEN' | translate)"
                          [readonly] = "readonly"
        ></app-custom-input>
      </div>
    </div>
    <div *ngIf="effectivelyVisible.includes('gruende')"
         id="gruendeInput" class="row row-cols-1 form-group mt-0 mb-0">
      <app-textarea
        class="flex-grow-1"
        [label] = "fieldConfigService.getFieldLabel('gruende', fieldConfig, 'FAHRKOSTEN-DETAIL.GRUENDE' | translate)"
        [rows] = "3"
        [customFormGroup] = "fahrkostenKostenUniversalForm"
        id = "gruende"
        noteText="{{'FAHRKOSTEN-DETAIL.GRUENDE' | translate }}"
        [readonly]="readonly">
      </app-textarea>
    </div>
    <div *ngIf="effectivelyVisible.includes('mitfahrerBei')"
         id="mitfahrerBeiInput" class="row row-cols-1 form-group mt-0 mb-0">
      <app-custom-input id="mitfahrerBei"
                        [customFormGroup] = "fahrkostenKostenUniversalForm"
                        [label] = "fieldConfigService.getFieldLabel('mitfahrerBei', fieldConfig, 'FAHRKOSTEN-DETAIL.MITFAHRER' | translate)"
                        [readonly] = "readonly"
      ></app-custom-input>
    </div>
    <div *ngIf="effectivelyVisible.includes('mitgenommen')"
         id="mitgenommenInput" class="row row-cols-1 form-group mt-0 mb-0">
      <app-custom-input
        id="mitgenommen"
        [customFormGroup] = "fahrkostenKostenUniversalForm"
        [label] = "fieldConfigService.getFieldLabel('mitgenommen', fieldConfig, 'FAHRKOSTEN-DETAIL.MITFAHRENDE' | translate)"
        [readonly] = "readonly"
      ></app-custom-input>
    </div>
    <!--ende: felder aus fahrkostenFahrzeug-->

    <!--neu: mitfahrer aufschlüsselung-->
    <div *ngIf="effectivelyVisible.includes('hasSchuelermitnahme')"
         [ngClass]="{'form-check-disabled' : readonly, 'form-check-active' : !readonly}">
      <label class="checkbox-container"  style="margin-bottom:2ch;">
        {{fieldConfigService.getFieldLabel('hasSchuelermitnahme', fieldConfig, 'FAHRKOSTEN-DETAIL.SCHUELERMITNAHME' | translate)}}
        <input type="checkbox" class="control control-checkbox custom-control-input"
               formControlName="hasSchuelermitnahme"
               id="hasSchuelermitnahme"
               name="hasSchuelermitnahme"
        >
        <span class="checkmark"></span>
      </label>
      <div id="mitfahrer1"
           *ngIf="effectivelyVisible.includes('mitfahrer1')"
           class="row row-cols-3 form-group mb-0">
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer1Name"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [label] = "'STANDARD.NAME' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer1Vorname"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [label] = "'STANDARD.VORNAME' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col col-lg-3 mt-0 mb-0">
          <app-custom-input
            id="mitfahrer1Anzahl"
            [type] = "'number'"
            [min]="0"
            [max]="28"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [label] = "'FAHRKOSTEN-DETAIL.ANZAHL' | translate"
            [title] = "'FAHRKOSTEN-DETAIL.ANZAHL-MITNAHMEN' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
      </div>
      <div id="mitfahrer2"
           *ngIf="effectivelyVisible.includes('mitfahrer2')"
           class="row row-cols-3 form-group mb-0" style="margin-top:-20px;">
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer2Name"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer2Vorname"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col col-lg-3 mt-0 mb-0">
          <app-custom-input
            id="mitfahrer2Anzahl"
            [type] = "'number'"
            [min]="0"
            [max]="28"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [title] = "'FAHRKOSTEN-DETAIL.ANZAHL-MITNAHMEN' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
      </div>
      <div id="mitfahrer3"
           *ngIf="effectivelyVisible.includes('mitfahrer3')"
           class="row row-cols-3 form-group mb-0" style="margin-top:-20px;">
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer3Name"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer3Vorname"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col col-lg-3 mt-0 mb-0">
          <app-custom-input
            id="mitfahrer3Anzahl"
            [type] = "'number'"
            [min]="0"
            [max]="28"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [title] = "'FAHRKOSTEN-DETAIL.ANZAHL-MITNAHMEN' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
      </div>
      <div id="mitfahrer4"
           *ngIf="effectivelyVisible.includes('mitfahrer4')"
           class="row row-cols-3 form-group mb-0" style="margin-top:-20px;">
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer4Name"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer4Vorname"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col col-lg-3 mt-0 mb-0">
          <app-custom-input
            id="mitfahrer4Anzahl"
            [type] = "'number'"
            [min]="0"
            [max]="28"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [title] = "'FAHRKOSTEN-DETAIL.ANZAHL-MITNAHMEN' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
      </div>
      <div id="mitfahrer5"
           *ngIf="effectivelyVisible.includes('mitfahrer5')"
           class="row row-cols-3 form-group mb-0" style="margin-top:-20px;">
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer5Name"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col mt-0 mb-0">
          <app-custom-input
            id="mitfahrer5Vorname"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
        <div class="col col-lg-3 mt-0 mb-0">
          <app-custom-input
            id="mitfahrer5Anzahl"
            [type] = "'number'"
            [min]="0"
            [max]="28"
            [customFormGroup] = "fahrkostenKostenUniversalForm"
            [title] = "'FAHRKOSTEN-DETAIL.ANZAHL-MITNAHMEN' | translate"
            [readonly] = "readonly"
          ></app-custom-input>
        </div>
      </div>
    </div>

    <!--belege-->
    <div *ngIf="effectivelyVisible.includes('belegUpload')">
      <hr class="hr-fahrkosten mt-1 mb-3" >

      <div class="row ml-2 cardAdd mb-2 mt-0" *ngIf="!readonly">
        <label [for]="'file-input'+kostenId" style="font-size:14px;cursor:pointer;margin-left:8px;color:black;"
               title="{{'FAHRKOSTEN-DETAIL.DATEIEN.HINZUFUEGEN'|translate}}">
          <fa-icon [icon]=faPlus
                   class="fa-xl custom-card-btn-addbeleg"
                   style="margin-right:8px;"
                   id="addBelegIcon"
          ></fa-icon>
          {{'FAHRKOSTEN-DETAIL.DATEIEN.HINZUFUEGEN'|translate}}
        </label>
        <input [id]="'file-input'+kostenId"
               type="file" style="width:0;height:0;"
               [accept]="allowedNachweisFormats"
               (change)="addBeleg($event)"/>
      </div>

      <div class="row ml-2 cardAdd mb-2 mt-0" *ngIf="readonly">
        <label style="font-size:14px;cursor:pointer;margin-left:8px;color:black;">Belege</label>
      </div>
      <div  class="col mb-1" *ngFor="let belegId of getBelegeMapKeys()" style="margin-left:8px;">
        <app-fahrkosten-belege-sb-false
          [beleg]    = "belegeList.get(belegId)"
          [readonly] = readonly
          (deleteThisBeleg) = "deleteBeleg($event)"
        ></app-fahrkosten-belege-sb-false>
      </div>
    </div>
    <!--end: belege-->
  </form>
</div>

